import React from "react";
import { Plus, X } from "lucide-react";

import { inputClass } from "../marketUpdateTheme";

export const MAX_VENDORS = 4;
export const emptyVendor = () => ({ first_name: "", last_name: "", mobile: "", email: "" });

const Field = ({ label, children }) => (
  <label className="block">
    <span className="block text-sm font-semibold text-gray-800 mb-1.5">{label}</span>
    {children}
  </label>
);

/**
 * Step 1, Vendor. Christian: "The owners details will already be in our system
 * but you can have this screen pop up to confirm details or add other vendor
 * details." Prefilled from the contact the report started from.
 */
const MarketUpdateVendorStep = ({ property, onPropertyChange, vendors, onVendorsChange }) => {
  const update = (index, key, value) => {
    onVendorsChange(vendors.map((v, i) => (i === index ? { ...v, [key]: value } : v)));
  };

  return (
    <div className="max-w-3xl mx-auto space-y-5">
      <section className="bg-white border border-gray-200 rounded-xl p-5">
        <h2 className="text-base font-bold text-gray-900 mb-4">Property</h2>
        <div className="grid grid-cols-1 sm:grid-cols-[1fr_200px] gap-4">
          <Field label="Address">
            <input className={inputClass} value={property.full_address}
              onChange={(e) => onPropertyChange({ full_address: e.target.value })} />
          </Field>
          <Field label="Suburb">
            <input className={inputClass} value={property.suburb}
              onChange={(e) => onPropertyChange({ suburb: e.target.value })} />
          </Field>
        </div>
      </section>

      {vendors.map((vendor, index) => (
        <section key={index} className="bg-white border border-gray-200 rounded-xl p-5">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-base font-bold text-gray-900">Vendor {index + 1}</h2>
            {vendors.length > 1 && (
              <button
                type="button"
                onClick={() => onVendorsChange(vendors.filter((_, i) => i !== index))}
                className="inline-flex items-center gap-1 px-2 py-1 rounded-md text-sm text-gray-600 hover:bg-gray-100 hover:text-gray-900"
              >
                <X className="w-4 h-4" /> Remove
              </button>
            )}
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <Field label="First name">
              <input className={inputClass} value={vendor.first_name} autoComplete="off"
                onChange={(e) => update(index, "first_name", e.target.value)} />
            </Field>
            <Field label="Last name">
              <input className={inputClass} value={vendor.last_name} autoComplete="off"
                onChange={(e) => update(index, "last_name", e.target.value)} />
            </Field>
            <Field label="Mobile number">
              <div className="flex">
                <span className="inline-flex items-center px-3 rounded-l-lg border border-r-0 border-gray-300 bg-gray-50 text-sm text-gray-600">+61</span>
                <input className={`${inputClass} rounded-l-none`} value={vendor.mobile} inputMode="tel" autoComplete="off"
                  placeholder="0412 345 678"
                  onChange={(e) => update(index, "mobile", e.target.value)} />
              </div>
            </Field>
            <Field label="Email">
              <input className={inputClass} value={vendor.email} type="email" autoComplete="off"
                onChange={(e) => update(index, "email", e.target.value)} />
            </Field>
          </div>
        </section>
      ))}

      {vendors.length < MAX_VENDORS && (
        <button
          type="button"
          onClick={() => onVendorsChange([...vendors, emptyVendor()])}
          className="inline-flex items-center gap-1.5 px-4 py-2.5 rounded-lg border border-dashed border-gray-300 bg-white text-sm font-semibold text-gray-800 hover:border-gray-400 hover:bg-gray-50"
        >
          <Plus className="w-4 h-4" /> Add vendor
        </button>
      )}
    </div>
  );
};

export default MarketUpdateVendorStep;
